
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../../api/tmdbApi";
import SessionPopup from "../SessionPopup"
import axios from 'axios';
import moment from "moment";

import Select from 'react-select';
import Loader from "../../components/loader";
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import * as Config from "../../constants/Config";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, country, appname } = window.app;

const ClientUserDetails  = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [countries, setCountries] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [storeError, setStoreError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({ contactname: '', phone: '', usertype: '', status: '', idc: '',store:'' });
    const [permission, setPermission] = useState({});
    const [success, setSuccess] = useState(false);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const[storeData,setStoreData]=useState([])
    const { route, setRoute, setCurrentPage, setRowsPerPage,setActiveMenuObj, usePrevious, userData, setActiveMenuId ,GetTimeActivity} = useContext(contentContext);


    const loginType = localStorage.getItem('login_type'); 
    const useruniqueid = loginType === 'admin' ? localStorage.getItem("userId") : localStorage.getItem("clientid")
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {
 
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
          toast[toastType](toastMessage, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
    
          // Clear the message after showing to prevent re-triggering
          setToastMessage("");
        }
      }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();
          

        }
        
            getStore()
        
        // getManagers();
     GetCountries();
    
        // userActivity();
    }, []);
    const getStore = (e) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        // const userdata = localStorage.getItem("userdata")
        // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        // console.log('userToken--->',userToken)
        axios({
            method: 'POST',
            url: `${lambda}getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                const result = response?.data?.result;
                if (result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {

                    if (result?.length > 0) {
                        
                        console.log("resulttttttttttttttttttttttttttttttttttt",result)
                        // setIsLoading(false)
                        setLocationData(result)
                        //  editUser?.companydetails?.[0].accountmanager
                    } else {
                        // setInvalidContent(true)
                        setIsLoading(false)
                        setLocationData(response?.data?.result)
                    }

                }

                // setDisableSaveBtn(false)
            });
    }
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] :path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


   const previousId = localStorage.getItem("previousid");
const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const GetCountries = async () => {
        try {
            console.log(tmdbApi);
            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection":"tiny"
            });

            // console.log(response?.result);
            if (response?.result.data==="Invalid token or Expired") {
                setShowSessionPopupup(true)
            } else {
                setCountries(response?.result.data);
                const usaCountry = response?.result.data.filter(
                    eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
                );
                if(!id){
                    setEditUser((prevUser) => ({
                        ...prevUser, 
                        idc: usaCountry?.[0]?.alpha3 || ""
                    }));
                }
               
                
              
            }
        } catch {
            console.log("error");
        }
    };
console.log("editUser-------------------->",editUser)
    const getuser = (e) => {
        GetTimeActivity()   
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/clientUserInfo?appname=' + appname+"&clientid="+id 
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                        setStoreData(response?.data?.result?.[0]?.store)

                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const onclickInvalid = () => {
        GetTimeActivity()   
        setInvalidContent(false)
        navigate('/usermanagement')
    }

    const getManagers = (e) => {
        GetTimeActivity()   
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/users?appname=' + appname + "&token=" + token + "&type=MANAGER",
        })
            .then(function (response) {
                console.log(response);
                setManagers(response?.data?.result)
            });
    }



    const getPermissions = (userType) => {
        GetTimeActivity()   
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/userPermissions?appname=' + appname + '&type=' + userType + "&token=" + token,
        })
            .then(function (response) {
                console.log("response?.data?.result?.data[0]", response?.data?.result?.data[0])
                if (response?.data?.result==="Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setPermission(response?.data?.result?.data[0].permissions)
                }
            });
    }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        
        setEditUser((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('typeeeeeeeeee', value);
        console.log('nameeeee', name);
    
        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }  
        
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces
    
            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
    
            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }
        
        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        } 
        
        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }  
        
        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    

    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        GetTimeActivity()   
        setSuccess(false);
        navigate("/users")
    };

    const handleAddUser = (e) => {
        GetTimeActivity()   
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()   
        let formIsValid = true;
        if (editUser?.emailId===undefined || editUser?.emailId?.trim()==="") {
            setEmailError("Please enter Email");
            setTimeout(function () { setEmailError("") }, 3000);
            formIsValid = false;
        }
        const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        if (regEx.test(editUser?.emailId)) {
            setEmailError("");
            setTimeout(function () { setEmailError("") }, 3000)
        } else if (!regEx.test(editUser?.emailId) && editUser?.emailId !== "") {
            setEmailError("Please Enter Valid Email");
            setTimeout(function () { setEmailError("") }, 3000)
            formIsValid = false;
        }

        if (editUser?.contactname===undefined || editUser?.contactname?.trim()==="") {
            setNameError("Please enter contact Name");
            setTimeout(function () { setNameError("") }, 3000);
            formIsValid = false;
        }

        if (!editUser?.phone?.trim()) {
            setPhoneError("Enter phone number");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        }else 
         if (
            (editUser.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(editUser.phone)) ||
            (editUser.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(editUser.phone))
        ) {
            setPhoneError("Invalid phone number format");
            setTimeout(() => setPhoneError(""), 3000);
            formIsValid = false;
        }
        
        
 
        if (editUser?.usertype==="") {
            setTypeError("Please select Type");
            setTimeout(function () { setTypeError("") }, 3000);
            formIsValid = false;
        }

        if (!storeData || storeData.length === 0) {
            setStoreError("Please select Store");
            setTimeout(() => setStoreError(""), 3000);
            formIsValid = false;
          }
          

        // if (editUser?.type === "ACCOUNTMANAGER" || editUser?.type === "CONTENTMANAGER" || editUser?.type === "MANAGER") {
        //     if (editUser?.manager === "" || editUser?.manager === undefined) {
        //         setManagerTypeError("Please select Manager");
        //         setTimeout(function () { setManagerTypeError("") }, 3000);
        //         formIsValid = false;
        //     }
        // }

        return formIsValid;
    }

    
const handleSubmit = () => {
    // const filterData= locationData?.filter((item)=>item?.name===storeData)
   
    GetTimeActivity()   
    setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "emailId": editUser?.emailId?.trim(),
            "usertype": editUser?.usertype,
            "contactname": editUser?.contactname?.trim(),
          
            "idc": editUser?.idc,
            "phone": editUser?.phone,
            // "manager": editUser?.manager ? editUser?.manager : "",
            // "permissions": permission,
            // "status": "PENDING REGISTRATION",
            "store": storeData,
            "status": "ACTIVE",
           
          
        }

        if (checkStatus === false) {
            delete payload["status"];
            delete payload["userType"];
        }

        axios({
            method: 'POST',
            url: lambda + '/clientUpdateUser?appname=' + appname + '&clientid=' + id + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result==="Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.data?.result==="This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        setToastMessage("User Details Updated Successfully")
                        setToastType("success")
                        // GetClientDataContext()
                    }
                }

            });
}


    const handleUpdate = (e) => {
        GetTimeActivity()   
        const isValid = formvalidation();
            if (isValid) {
                handleSubmit();
            }
    }
    console.log('userData',userData)
    const createuser = async () => {
        // const filterData= locationData?.filter((item)=>item?.name===storeData)
        setIsLoading(true)
        
        // GetTimeActivity()   
        let payload = {}
        payload = {
            "emailId": editUser?.emailId?.trim(),
            "usertype": editUser?.usertype,
            "contactname": editUser?.contactname?.trim(),
            
            "idc": editUser?.idc,
            "phone": editUser?.phone,
         
            // "manager": editUser?.manager ? editUser?.manager : "",
            // "permissions": permission,
            // "status": "PENDING REGISTRATION",
            "store": storeData,
            "status": "ACTIVE",
            "createdBy": { clientid: userData?.clientid, username: userData?.contactname }
        }
        const token = localStorage.getItem("token")
        axios({
            method: 'PUT',
            url: lambda + "/clientAddUser?appname=" + appname ,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        // setExistMsg(true)
                        setToastMessage("User already exists")
                        setToastType("warning")
                        
                    }
                    else if (response?.result==="Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        setToastMessage("User Details Created Successfully")
                        setToastType("success")
                        setTimeout(() => {
                           navigate("/clientusers"); // Trigger API call AFTER toast is displayed
                          }, 2000); // Delay ensures toast is seen before re-render
                      
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()   
        if (id) {
            navigate({
                pathname: "/clientusers",
                state: { search: true }
            });
        } else {
            navigate("/clientusers")
        }
    }

    const CancelClick = () => {
        GetTimeActivity()   
        setIsMsg(false);
        navigate("/users")
    }
    const handleMultiSelect = (selectedOptions) => {
        if (Array.isArray(selectedOptions)) {
          const selectedData = selectedOptions.map(option => ({
            locationname: option.value,
            storeid: option.storeid
          }));
          console.log("Selected Data:", selectedData);
          setStoreData(selectedData); // Store the custom formatted array in state
        } else if (selectedOptions) {
          const selectedData = [{
            locationname: selectedOptions.value,
            storeid: selectedOptions.storeid
          }];
          console.log("Selected Data:", selectedData);
          setStoreData(selectedData); // Store as an array for consistency
        } else {
          setStoreData([]);
        }
      };
      

    const handleSelectAll = (e, updatedType, menuItemIndex, submenuIndex) => {
        const checked = e.target.checked;
        // console.log('menuItemIndex',menuItemIndex)
        // console.log('submenuIndex',submenuIndex)
        setPermission(prevState => {
            if (submenuIndex === undefined) {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedDashboard = Object.keys(menuItem.dashboard).reduce((obj, key) => {
                            obj[key] = { ...menuItem.dashboard[key], [updatedType]: checked };
                            return obj;
                        }, {});
                        return { ...menuItem, [updatedType]: checked, dashboard: updatedDashboard };
                    }
                    return menuItem;
                });
            } else if (submenuIndex === "submenus") {
                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        // console.log('menuItem.submenus',menuItem.submenus)
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {

                            const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                return obj
                            }, {});

                            return { ...submenu, [updatedType]: checked, dashboard: kk };

                        });
                        return { ...menuItem, [updatedType]: checked, submenus: updatedSubmenus };

                    }
                    return menuItem;
                });
            }

            else {

                return prevState.map((menuItem, i) => {
                    if (i === menuItemIndex) {
                        const updatedSubmenus = menuItem.submenus.map((submenu, j) => {
                            if (j === submenuIndex) {

                                const kk = Object.keys(submenu.dashboard).reduce((obj, key) => {
                                    obj[key] = { ...submenu.dashboard[key], [updatedType]: checked };
                                    return obj
                                }, {});

                                return { ...submenu, [updatedType]: checked, dashboard: kk };
                            }
                            return submenu;
                        });
                        return { ...menuItem, submenus: updatedSubmenus };
                    }
                    return menuItem;
                });
            }
        });
        console.log('permissionss',permission)
    };

    const handleChangeEachItem = (e, index, subIndex, type, typeOfItem, updatedType, subSubIndex) => {
        const updatedPermission = [...permission];
        const isChecked = e.target.checked;
        // console.log('typeeee',type)
        // console.log('index',index)
        // console.log('subIndex',subIndex)
        // console.log('updatedPermission',updatedPermission)
        // console.log('typeOfItem',typeOfItem)
        if (typeOfItem === 'dashboard') {
            updatedPermission[index].dashboard[type][updatedType] = isChecked;
        } else if (typeOfItem === 'submenus') {
            updatedPermission[index].submenus[subSubIndex].dashboard[type][updatedType] = isChecked;
            if (isChecked && updatedPermission[index].dashboard) {
                Object.keys(updatedPermission[index].dashboard).forEach(key => {
                    updatedPermission[index].dashboard[key][updatedType] = true;
                });
            }
        }

        setPermission(updatedPermission);
    };


     console.log("storeeeeeeeeeeeNameeeeee", storeData);

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

<div className="main-content user-management create-user" id="main-content">
<div className="page-content" id="page-content">
    <div className="container-fluid" id="container-fluid">
        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
            <div className="col-lg-12">
                <div className="d-flex align-items-center">
                    <div className="flex-grow-1">
                        <h4 className="mb-2 card-title" id="breadcrumb-title">{id===undefined ? "ADD USER" : "EDIT USER"}</h4>
                        <p className="menu-path" id="breadcrumb-path">
                            <span>User Management</span> / <b id="breadcrumb-action">{id===undefined ? "ADD USER" : "EDIT USER"}</b>
                        </p>
                    </div>
                    <div>
                        <a id="back-button" onClick={handleBack} className="stroke-btn-style">
                            <span className="material-symbols-outlined">arrow_back</span>back
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div className="create-user-block" id="create-user-block">
            {Object.keys(editUser)?.length > 0 ? (
                <>     
                    <div className="form-block" id="form-block">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="col-md-12">
                                    <div className="mb-3 input-field">
                                        <label className="form_label">NAME<span className="required">*</span></label>
                                        <input id="name" name="contactname" placeholder="Enter Name" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.contactname} />
                                        <span id="name-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
  <div className="mb-3 input-field">
    <label className="form_label" htmlFor="usertype-select">
      USER TYPE<span className="required">*</span>
    </label>
    <select 
      id="usertype-select" 
      className="colorselect capitalize form-control form-select" 
      name="usertype" 
      onChange={(e) => handleChange(e)} 
      value={editUser?.usertype}
   
    >
    <option value="" id="usertype-option-default">Select Type</option>

{userData?.usertype === "BRAND MANAGER" && (
  <>
    <option value="BRAND MANAGER" id="usertype-option-brandmanager">Brand Manager</option>
    <option value="STORE MANAGER" id="usertype-option-storemanager">Store Manager</option>
    <option value="SECURITY" id="usertype-option-security">Security</option>
  </>
)}



{userData?.usertype === "STORE MANAGER" && (
    <>
     <option value="STORE MANAGER" id="usertype-option-storemanager">Store Manager</option>
     <option value="SECURITY" id="usertype-option-storemanager">Security</option>
    </>
 
)}

    </select>
   
    <span 
      id="usertype-error" 
      className="errormsg" 
      style={{ fontWeight: 'bold', color: 'red' }}
    >
      {typeError}
    </span>
  </div>
</div>
<div className="col-md-12">
  <div className="mb-3 input-field">
    <label className="form_label" htmlFor="usertype-select">
      Stores<span className="required">*</span>
    </label>
    <Select
  options={Array.isArray(locationData) &&locationData?.map(item => ({ value: item?.name, label: item?.name,storeid: item?.storeid, }))}
  isMulti={editUser?.usertype !== "SECURITY"}
  value={Array.isArray(storeData) && storeData.map(item => ({ value: item.locationname, label: item.locationname, storeid: item.storeid }))}
  onChange={handleMultiSelect}
  placeholder="Select options..."
/>
    {/* <select 
      id="usertype-select" 
      className="colorselect capitalize form-control form-select" 
      name="store" 
      onChange={(e) => handleChange(e)} 
      value={storeData}
   
    >
      <option value="" id="usertype-option-default">Select Store</option>
     
      {locationData&&locationData?.map((item)=>{
        return(
<option value={item?.name} id="usertype-option-superadmin">{item?.name}</option>
        )
      })}
      
    
    </select> */}
    <span 
      id="usertype-error" 
      className="errormsg" 
      style={{ fontWeight: 'bold', color: 'red' }}
    >
      {storeError}
    </span>
  </div>
</div>

                                <div className="col-md-12">
                                    <div className="mb-3 input-field">
                                        <label className="form_label">E-MAIL ID<span className="required">*</span></label>
                                        <input id="email" name="emailId" placeholder="Enter Your Email" type="email" className="form-control" aria-invalid="false" value={editUser?.emailId} disabled={id !== undefined} onChange={(e) => handleChange(e)} />
                                        <span id="email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="mb-3 input-field">
                                        <label className="form_label">CONTACT NUMBER <span className="required">*</span></label>
                                        <div className="country-code">
                                            <select id="country-code" name="idc" value={editUser?.idc} className="colorselect capitalize" onChange={(e) => handleCountryChange(e)}>
                                            {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                return (
                                                                                    <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                                )
                                                                            }
                                                                            )}
                                            </select>
                                            <input id="contact-number" className="form-control contact-number" type="tel" name="phone" value={editUser?.phone} placeholder="Enter Phone Number" onChange={(e) => handleChange(e)} />
                                            <span id="idc-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                            <span id="phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <button id="submit-button" className="fill-btn-style" type="submit" onClick={e => id===undefined ? handleAddUser(e) : handleUpdate(e)}>
                                {isLoading ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" alt="loading" />) : null}
                                {id===undefined ? "Create" : "Update"}
                            </button>
                        </div>
                        {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                    </div>
                </>
            ) : (
                <div className="form-block" id="loading-block">
                    <div className="tab-content p-3 text-muted">
                        <div className="tab-pane active show" id="home1" role="tabpanel">
                            <div className="row">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
</div>
</div>

                }



            </div>
            <ToastContainer
               id="toastContainer"
               position="bottom-center"
               autoClose={3000}
               hideProgressBar={false}
               newestOnTop={false}
               closeOnClick
               rtl={false}
               pauseOnFocusLoss
               draggable
               pauseOnHover={false}
               theme="light"
             />

        </>
    );
};

export default ClientUserDetails;
